import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { MapService } from 'src/app/Service/map.service';
import { defaults as defaultInteractions, Draw } from 'ol/interaction';
import { Fill, Stroke, Style } from "ol/style";
import { Polygon } from "ol/geom";
import { defaults as defaultControls, FullScreen } from 'ol/control';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { XYZ } from "ol/source";
import TileLayer from 'ol/layer/Tile';
import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import Feature from "ol/Feature";
import BingMaps from "ol/source/BingMaps";
import axios from 'src/app/Service/axios';
import * as olProj from 'ol/proj';
import * as moment from 'moment-jalaali';
import * as XLSX from 'xlsx';

declare let $: any;

@Component({

  selector: 'app-cctv-video-locations',

  templateUrl: './cctv-video-locations.component.html',

  styleUrls: ['./cctv-video-locations.component.css']

})

export class CctvVideoLocationsComponent implements OnInit {

  map: any;

  source: any;

  vector: any;

  polygonEvent: any;

  draw: any;

  vectorLayer: any;

  list_City: any[] = [];

  list_Parking: any[] = [];

  list_Search: any[] = [];

  layers: any = [];

  editMode: boolean = false;

  mapShowMode: boolean = false;

  mapSatelait: boolean = false;

  ismapCreate: boolean = false;

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  mdl_Add: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iVS_Parking: new FormControl(''),

    strCode: new FormControl('', Validators.required),

    strName: new FormControl('', Validators.required),

    strMediaPath: new FormControl('', Validators.required),

    strIP: new FormControl('', Validators.required),

    strComment: new FormControl(''),

    tiParkingType: new FormControl('', Validators.required),

    bActive: new FormControl(''),

    iFloor: new FormControl('', Validators.required),

    iChargingStation: new FormControl('', Validators.required),

    iCapacity: new FormControl('', Validators.required),

    strCity: new FormControl('', Validators.required),

    strAddress: new FormControl('', Validators.required),

    strEContractDate: new FormControl(''),

    strSContractDate: new FormControl(''),

    tiOwnershipStatus: new FormControl('', Validators.required),

    lstPoints: new FormControl(''),

    index: new FormControl(''),


  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private mapService: MapService

  ) { }

  ngOnInit(): void {

    this.initialize();

  }

  initialize = async () => {

    this._otherService.Showspinner()

    let res_1 = JSON.parse((await axios.post(`VS_Parking_List`, this._otherService.stringNumberToNumber(this.mdl_Add.value))).data.toString());

    this._otherService.nonespinner()

    if (res_1.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x110' } });

      return;

    }

    if (res_1.iResult == 0) return this._tooltip.showError(res_1.strError);

    this.list_Parking = res_1;

    this.list_Search = res_1;

    this._otherService.Showspinner()

    let res_2 = JSON.parse((await axios.post(`City_List`, this._otherService.stringNumberToNumber(this.mdl_Add.value))).data.toString());

    this._otherService.nonespinner()

    this.list_City = res_2;

  }

  openAddModal(item?: any, index: number = 0) {

    const tempStorage = this.list_City;

    this.list_City = [];

    setTimeout(() => {

      this.list_City = tempStorage;

    }, 100);

    if (item) {

      this.editMode = true;

      Object.keys(item).forEach(key => {

        this.mdl_Add.get(key)?.setValue(item[key])

      })

      this.mdl_Add.get('index')?.setValue(index)

      $("#add_Modal").modal('show');

    }

    else {

      this.mdl_Add.patchValue({

        strCode: '',

        strName: '',

        strMediaPath: '',

        strIP: '',

        strComment: '',

        tiParkingType: '',

        bActive: true,

        iFloor: '',

        iChargingStation: '',

        iCapacity: '',

        strCity: '',

        strAddress: '',

        strEContractDate: '',

        strSContractDate: '',

        tiOwnershipStatus: '',

        lstPoints: '',

      });

      this.editMode = false;

      $("#add_Modal").modal('show');

    }

  }

  openAreaMap() {

    $("#mapArea_Modal").modal('show');

    if (this.mdl_Add.get('lstPoints')?.value != '' && this.mapShowMode) {

      this.mapService.removeLayerByName('polygon', this.map);

    }

    this.mapShowMode = false;

    if (!this.editMode) {

      this.mdl_Add.patchValue({

        lstPoints: ''

      })

    }

    setTimeout(() => {

      if (!this.ismapCreate) {

        this.source = new VectorSource({ wrapX: false });

        this.vector = new VectorLayer({

          source: this.source,

        });

        if (this.bOfflineMap) {

          this.layers.push(

            new TileLayer({

              source: new XYZ({

                // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

                url: this.strMapUrl,

                attributions: 'Map data © RayanAndishehNasr' // 

              }),

            })

          );

        }

        else {

          const styles = [

            'AerialWithLabelsOnDemand',

          ];

          let i, ii;

          for (i = 0, ii = styles.length; i < ii; ++i) {

            this.layers.push(

              new TileLayer({

                visible: false,

                // visible: (styles[i] === 'AerialWithLabelsOnDemand') ? true : false,

                preload: Infinity,

                source: new BingMaps({

                  // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                  key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',
                  imagerySet: styles[i],

                }),

              }),

            );
          }

          // this.layers.push(new TileLayer({ source: new OSM({}),visible: false }), this.vector)

          this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)


        }

        this.map = new Map({

          layers: this.layers,

          target: 'test',

          view: new View({

            center: olProj.fromLonLat([51.3833554, 35.6770113]),

            zoom: 13,

          }),

        });

        this.ismapCreate = true;

      }

    }, 500);

    setTimeout(() => {

      this.vector.getSource().on('addfeature', (e: any) => {

        this.polygonEvent = e.feature;

        this.source.removeFeature(e.feature);

        this.source.removeFeature(this.polygonEvent);

        this.savePolygon();

      });

      const value = 'Polygon';

      this.draw = new Draw({

        source: this.source,

        type: value,

      });

      this.map.addInteraction(this.draw);

    }, 700);

  }

  showArea() {

    this.mapShowMode = true;

    $("#mapArea_Modal").modal('show');

    setTimeout(() => {

      this.showPolygon(this.mdl_Add.get('lstPoints')?.value)

    }, 800);

    setTimeout(() => {

      if (!this.ismapCreate) {

        this.source = new VectorSource({ wrapX: false });

        this.vector = new VectorLayer({

          source: this.source,

        });


        if (this.bOfflineMap) {

          this.layers.push(

            new TileLayer({

              source: new XYZ({

                // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

                url: this.strMapUrl,

                attributions: 'Map data © RayanAndishehNasr' // 

              }),

            })

          );

        }

        else {

          const styles = [

            'AerialWithLabelsOnDemand',

          ];

          let i, ii;

          for (i = 0, ii = styles.length; i < ii; ++i) {

            this.layers.push(

              new TileLayer({

                visible: false,

                preload: Infinity,

                source: new BingMaps({

                  // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                  key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',


                  imagerySet: styles[i],

                }),

              }),

            );
          }

          this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


        }

        this.map = new Map({

          layers: this.layers,

          target: 'test',

          view: new View({

            center: olProj.fromLonLat([51.3833554, 35.6770113]),

            zoom: 13,

          }),

        });

        this.ismapCreate = true;
      }

    }, 500);

    setTimeout(() => {

      this.vector.getSource().on('addfeature', (e: any) => {

        this.polygonEvent = e.feature;

        this.source.removeFeature(e.feature);

        this.source.removeFeature(this.polygonEvent);

        this.savePolygon();

      });

      const value = 'Polygon';

      this.draw = new Draw({

        source: this.source,

        type: value,

      });

      this.map.addInteraction(this.draw);

    }, 700);

  }

  filter_list(val: any) {

    this.list_Parking = this.list_Search.filter((el: any) => {

      return el?.iVS_Parking?.toString().includes(val.value)

        || el.strName?.toString().includes(val.value)

        || el.strCityName?.toString().includes(val.value)

        || el.strName?.toString().includes(val.value)

        || el.strParkingType?.toString().includes(val.value)

    });

    if (val.value.trim() == '') {

      this.list_Parking = this.list_Search;

    }

  }

  changeTail() {

    if (this.mapSatelait == false) {

      this.layers[1].setVisible(false);

      this.layers[0].setVisible(true);

    }

    else {

      this.layers[0].setVisible(false);

      this.layers[1].setVisible(true);

    }

    this.mapSatelait = !this.mapSatelait;

  }

  savePolygon = async () => {

    var point = [] as any;

    this.draw.sketchLineCoords_.forEach((item: any, index: any) => {

      var data = this.mapService.transformCoordinates(item);

      point.push({ fLat: data[1], fLon: data[0] });

    });

    this._tooltip.showSuccess("محدوده با موفقیت ترسیم شد.");

    this.showPolygon(point);

    this.mdl_Add.controls["lstPoints"].setValue(point);

  }

  showPolygon(point: any[],) {

    // Remove the previous polygon

    if (this.vectorLayer) this.map.removeLayer(this.vectorLayer);

    if (point.length != 0) {

      var ring = [];

      for (let index = 0; index < point.length; index++) {

        ring.push([point[index].fLon, point[index].fLat]);

      }

      var polygon = new Polygon([ring]);

      polygon.transform('EPSG:4326', 'EPSG:3857');

      var feature = new Feature(polygon);

      var vectorSource = new VectorSource();

      vectorSource.addFeature(feature);

      var vectorLayer = new VectorLayer({

        source: vectorSource,

        name: 'polygon',

        style: new Style({

          stroke: new Stroke({

            color: 'red',

            width: 4,

            lineDash: [10, 20, 10, 20]

          }),

          fill: new Fill({

            color: 'rgba(0, 0, 255, 0)'

          })

        }),

      } as any);


      this.vectorLayer = vectorLayer;

      this.map.addLayer(vectorLayer);

      this.fitToAll(point);


    }

  }

  submitRequest = async () => {

    if (this.mdl_Add.invalid) return this._tooltip.showError('موارد ستاره دار را وارد کنید!')

    if (this.mdl_Add.get('tiOwnershipStatus')?.value == 1) {

      if (this.mdl_Add.get('strSContractDate')?.value.trim() == '') return this._tooltip.showError('تاریخ شروع اجاره را وارد کنید!');

      if (this.mdl_Add.get('strEContractDate')?.value.trim() == '') return this._tooltip.showError('تاریخ پایان اجاره را وارد کنید!');

    }

    if (this.mdl_Add.get('tiOwnershipStatus')?.value != 1) {

      this.mdl_Add.patchValue({

        strSContractDate: '',

        strEContractDate: ''

      })
    }

    if (this.mdl_Add.get('lstPoints')?.value == '') {

      return this._tooltip.showError('محدوده پارکینگ را ترسیم کنید!');

    }

    if (this.editMode) {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this._otherService.Showspinner();

              let res = JSON.parse((await axios.post(`VS_Parking_Edit`, this._otherService.stringNumberToNumber(this.mdl_Add.value))).data.toString());

              this._otherService.nonespinner();

              if (res.ISSessionExpired == true) {

                this._tooltip.showError('لطفا وارد سیستم شوید');

                this._otherService.removeLocalStorage();

                this.router.navigate(['login'], { queryParams: { error: 'x110' } });

                return;

              }

              if (res.iResult == 0) return this._tooltip.showError(res.strError);

              this.list_Parking[this.mdl_Add.get('index')?.value] = res[0];

              this._tooltip.showSuccess('با موفقیت ویرایش شد');

              $("#add_Modal").modal('hide');

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

    else {

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`VS_Parking_Save`, this._otherService.stringNumberToNumber(this.mdl_Add.value))).data.toString());

      this._otherService.nonespinner();

      if (res.ISSessionExpired == true) {

        this._tooltip.showError('لطفا وارد سیستم شوید');

        this._otherService.removeLocalStorage();

        this.router.navigate(['login'], { queryParams: { error: 'x110' } });

        return;

      }

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this.list_Parking.push(res[0]);

      this._tooltip.showSuccess('با موفقیت ذخیره شده');

      $("#add_Modal").modal('hide');

    }

  }

  removeItem(item, index) {

    $.confirm({

      title: `آیا از حذف پارکینگ دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this._otherService.Showspinner()

            var model = {

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              iVS_Parking: item.iVS_Parking


            }

            let res = JSON.parse((await axios.post(`VS_Parking_Delete`, this._otherService.stringNumberToNumber(model))).data.toString());

            this._otherService.nonespinner()

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            else {

              this.list_Parking.splice(index, 1);

              this._tooltip.showSuccess(' با موفقیت حذف شد');

            }


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });
  }

  fitToAll(obj: any[]) {

    let maxLatitude = -Infinity;

    let maxLongitude = -Infinity;

    let minLatitude = Infinity;

    let minLongitude = Infinity;

    for (const item of obj) {

      if (item.fLat > maxLatitude) maxLatitude = item.fLat;

      if (item.fLon > maxLongitude) maxLongitude = item.fLon;

      if (item.fLat < minLatitude) minLatitude = item.fLat;

      if (item.fLon < minLongitude) minLongitude = item.fLon;
    }

    var model: any = {

      maxLatitude: maxLatitude,

      maxLongitude: maxLongitude,

      minLatitude: minLatitude,

      minLongitude: minLongitude

    }

    var view = this.map.getView();

    var transformedStart = this.mapService.transformCoordinates2([

      model.maxLongitude,

      model.maxLatitude,

    ]);

    var transformedEnd = this.mapService.transformCoordinates2([

      model.minLongitude,

      model.minLatitude,

    ]);

    var source = [
      Math.min(transformedStart[0], transformedEnd[0]) - 300,
      Math.min(transformedStart[1], transformedEnd[1]) - 300,
      Math.max(transformedStart[0], transformedEnd[0]) + 300,
      Math.max(transformedStart[1], transformedEnd[1]) + 300,
    ];

    view.fit(source);
  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this._otherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }

}
